import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase 설정을 서버 API에서 동적으로 가져오기
export const loadFirebaseConfig = async () => {
    const response = await fetch('/api/v1/firebase-config');
    if (!response.ok) {
        throw new Error('Failed to load Firebase configuration');
    }
    const config = await response.json();
    // console.log('Loaded Firebase Config:', config); // 디버깅: config 출력
    return config;
};

// Firebase 초기화 및 메시징 객체 반환
export const initializeFirebase = async () => {
    const config = await loadFirebaseConfig();
    // console.log('Config received:', config); // 디버깅: config 확인
    if (!config.vapidKey) {
        throw new Error('Missing vapidKey in Firebase configuration'); // 에러 처리
    }
    const app = initializeApp(config);
    const messaging = getMessaging(app);
    return { messaging, vapidKey: config.vapidKey };
};


// FCM 토큰 가져오기
export const fetchFCMToken = async (messaging, vapidKey, permission) => {
    try {
        const currentToken = await getToken(messaging, { vapidKey });
        if (currentToken) {
            // console.log('token : ' + currentToken);
            // console.log('permission : ' + permission, permission === 'granted');

            if (permission === 'granted') {
                axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                axios.post('/firebase-user', {
                    fcm_token: currentToken,
                })
                    .then(response => {
                        // console.log('Success:', response);
                    })
                    .catch(error => {
                        // console.log('Error:', error);
                    });
            }

            if (document.querySelector('input[name="fcm_token"]') != null) {
                document.querySelector('input[name="fcm_token"]').value = currentToken;
            }
            return currentToken;
        } else {
            // console.log('No registration token available.');
            return null;
        }
    } catch (err) {
        // console.error('An error occurred while retrieving token.', err);
        return null;
    }
};

// Foreground 메시지 수신 처리
export const handleIncomingMessages = async (messaging) => {
    if (!messaging) {
        // console.error('Messaging object is undefined. Check Firebase initialization.');
        return;
    }

    onMessage(messaging, (payload) => {
        function closeEvent() {
            const modal = document.getElementById("pushModal");
            if (modal) {
                modal.classList.remove('show');
                document.body.classList.remove('modal-open');
                modal.style.display = "none";
                document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
            }
        }

        function confirmEvent() {
            if (payload.data !== undefined && payload.data.link_url !== undefined) {
                window.open(payload.data.link_url, '_blank');
            }

            closeEvent();
        }

        closeEvent();

        let modal = document.getElementById('pushModal');
        let confirmBtn = document.getElementById('pushConfirmBtn');

        if (document.body.contains(modal)) {
            document.getElementById('pushModalTitle').innerHTML = payload.data.title;
            document.getElementById('pushModalBody').innerHTML = payload.data.message;
            confirmBtn.innerHTML = payload.data.btn ?? '확인';

            confirmBtn.removeEventListener('click', confirmEvent);
            confirmBtn.addEventListener('click', confirmEvent);
            document.getElementById('pushCloseBtn').addEventListener('click', closeEvent);
            document.addEventListener("click", function (event) {
                if (event.target === modal || event.target.classList.contains("close") || event.target.parentElement.classList.contains("close")) {
                    closeEvent();
                }
            });

            modal.style.display = "block";
            modal.classList.add('show');
            document.body.classList.add('modal-open');
            if (!document.querySelectorAll('.modal-backdrop').length) {
                let backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade', 'show');
                document.body.append(backdrop);
            }
        } else {
            alert(`${payload.data.title}\n${payload.data.message}`);
            confirmEvent();
        }

    });
};
